<template>
    <div class="flex flex-column items-center justify-center bg-black-40"
         style="height:100vh"
    >
        <vue-simple-spinner
                :size="64"
                message="Chargement en cours..."
                :spacing="25"
                text-fg-color="#FFF"
                :font-size="16"
        ></vue-simple-spinner>
    </div>
</template>


<script type="text/babel">
    export default {
        data() {
            return {}
        },
        components: {},
    };
</script>


// WEBPACK FOOTER //
// src/components/Spinner.vue